export { default } from './TableCell';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/TableCell/index.js
// module id = 415
// module chunks = 2